<template>
    <v-card :color="`${color} lighten-1`" dark class="v-card-body" @click="pushRute">
        <v-card :color="`${color} darken-2`" class="v-card-header" dark>
            <slot name="icon"></slot>
        </v-card>

        <v-card-text class="headline text-xs-center v-card-title">
            <div>
                {{ this.title }}
            </div>
        </v-card-text>

        <v-divider class="mx-3 mb-2" />

        <v-card-text class="text-xs-center pt-4 v-card-actions">
            <slot name="actions"></slot>
        </v-card-text>
    </v-card>
</template>

<script>
export default {
    name: "CardInfo",
    props: {
        color: {
            type: String,
            default: "blue"
        },
        title: {
            type: String,
            default: null
        },
        href: {
            type: String,
            default: null
        }
    },

    methods: {
        pushRute() {
            if (this.href !== "dashboard") {
                this.$router.push(this.href)
            }
        }
    }
}
</script>

<style>
.v-card-body {
    border-radius: 4px;
    box-shadow: #252932;
    height: 230px;
}

.v-card-body:hover {
    box-shadow: 0 8px 9px -5px rgba(0, 0, 0, 0.2), 0 15px 22px 2px rgba(0, 0, 0, 0.14),
        0 6px 28px 5px rgba(0, 0, 0, 0.12);
    border-radius: 0;
    cursor: pointer;
}

.v-card-header {
    width: 60px;
    height: 55px;
    margin-left: 2px;
    margin-top: -20px;
    position: absolute;
    elevation: 10deg;
    text-align: center;
    padding-top: 7px;
}

.v-card-title {
    padding-top: 65px;
}

.v-card-actions .v-icon:hover {
    color: #0f27d2;
    border-color: #150ed2;
}

.v-card-actions .v-btn:hover {
    width: 50px;
    height: 50px;
}
</style>
